import { useOutletContext } from 'react-router-dom'

import NewGroupModal from 'modules/expenses/components/expenses/New/GroupModal'
import type { RouteContextParams } from 'modules/expenses/lib/my_expenses/RouteContextParams'

const NewGroupModalPage = () => {
  const { back } = useOutletContext<RouteContextParams>()

  return <NewGroupModal back={back} />
}

export default NewGroupModalPage
